import { ChevronRightIcon, CircleCheckIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router";
import { Steps } from "@/components/steps";
import { Button } from "@/components/ui/button";

import { useSession } from "@/hooks/use-session";
import { useAppSelector } from "@/redux/store";

export default function Checkout() {
  const { service } = useParams();
  const { t } = useTranslation();
  const { session } = useSession();

  const order = useAppSelector((state) => state.order);

  return (
    <div className="space-y-24">
      <Steps className="mx-auto flex max-w-2xl" currentStep={4} />

      <div className="flex flex-col items-center gap-4">
        <CircleCheckIcon className="size-12 stroke-secondary" />
        <div className="flex flex-col items-center gap-2">
          <p className="font-medium text-lg">{t("checkout.title")}</p>
          <p>
            {service === "infinity"
              ? t("checkout.descriptions.infinity")
              : t("checkout.descriptions.rest")}
          </p>
        </div>
        {service === "infinity" ? (
          <Button asChild>
            <Link to="/">
              <span>{t("labels.finish")}</span>
              <ChevronRightIcon />
            </Link>
          </Button>
        ) : (
          <div className="flex flex-col items-center gap-4 sm:flex-row">
            {session && (
              <Button asChild className="w-full sm:w-48">
                <Link to={`/pay-with-wallet/${order.orderId}`}>
                  <span>{t("labels.pay-with-wallet")}</span>
                  <ChevronRightIcon />
                </Link>
              </Button>
            )}
            <Button asChild className="w-full sm:w-48">
              <Link to={`/payment/${order.orderId}`}>
                <span>{t("labels.pay-now")}</span>
                <ChevronRightIcon />
              </Link>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
